angular.module('statInsuranceMti', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);


// WEBPACK FOOTER //
// ./src/app/stat-insurance-mti/stat-insurance-mti.module.js